"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _help_1_ = _interopRequireDefault(require("../images/help_1_6.gif"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trade = {
  id: "trade",
  title: {
    en: "Lesson 6 (Trade)",
    de: "Lektion 6 (Handel)"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
      src: _help_1_.default,
      alt: "",
      style: {
        width: "390px",
        height: "274px",
        display: "block",
        margin: "16px auto"
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Trading with other users"), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, "If you would like to trade with other users for items, use 1:1 trade or individual merchants."), /*#__PURE__*/_react.default.createElement("li", null, "In 1 on 1 trade, click the target character and at the social menu, at the action tab use the trade button or use the trade shortcut key and then began trading at the trading window."), /*#__PURE__*/_react.default.createElement("li", null, "At the trade window, money and items can be traded, and when other characters agree to the trade, the trade will occure."), /*#__PURE__*/_react.default.createElement("li", null, "Individual merchants, the merchant command can only be used in the town, and you can purchase according to price they have set. Any user can open an individual market, even the same items can be sold in different shops at different prices, therefore make sure to shop around before you buy.")))
  }
};
var _default = trade;
exports.default = _default;